export const defaultBedrockReply =
  'I could not find an exact answer to the question. However, I found information that may be relevant.';

export const teleportRegions = [
  {
    name: 'auditorium',
  },
  { name: 'board room' },
  { name: 'beach' },
  { name: 'cafe' },
  { name: 'executive center' },
  {
    name: 'executive center second floor',
    ueName: 'executive center 2nd floor',
  },
  {
    name: 'executive center third floor',
    ueName: 'executive center 3rd floor',
  },
  { name: 'exhibit hall' },
  { name: 'garden' },
  { name: 'marina' },
];
// create a list of sentences including every region to match against voice recognition
export const teleportVoiceCommandList = ['teleport', 'take me']
  .map((x) => {
    return teleportRegions.map((y) => x + ' ' + y.name);
  })
  .flat(1);

// used for voice command recognition debug
export enum EKeyName {
  n = 'n',
  y = 'y',
  d1 = '1',
  d2 = '2',
  t = 't',
}
type keyInfo = {
  key: string;
  code: string;
  keyCode: number;
};
export const keys: { [key in EKeyName]: keyInfo } = {
  [EKeyName.n]: {
    key: 'n',
    code: 'KeyN',
    keyCode: 78,
  },
  [EKeyName.y]: {
    key: 'y',
    code: 'KeyY',
    keyCode: 84,
  },
  [EKeyName.d1]: {
    key: '1',
    code: 'Digit1',
    keyCode: 49,
  },
  [EKeyName.d2]: {
    key: '2',
    code: 'Digit2',
    keyCode: 50,
  },
  [EKeyName.t]: {
    key: 't',
    code: 'KeyT',
    keyCode: 89,
  },
};

enum EDebugVoiceCommandName {
  expressionNo = 'expression no',
  expressionYes = 'expression yes',
  expressionWave = 'expression wave',
  expressionApplaud = 'expression applaud',
  expressionTeleport = 'teleport',
}
export const debugVoiceCommand: { [key in EDebugVoiceCommandName]: keyInfo } = {
  [EDebugVoiceCommandName.expressionNo]: keys.n,
  [EDebugVoiceCommandName.expressionYes]: keys.y,
  [EDebugVoiceCommandName.expressionWave]: keys[1],
  [EDebugVoiceCommandName.expressionApplaud]: keys[2],
  [EDebugVoiceCommandName.expressionTeleport]: keys.t,
};

// TODO
export const actionsPromptOptionsExpression = [
  'expression no',
  'expression yes',
  'expression wave',
  'expression applaud',
];
